export const EVENT_FIRED = 'EVENT_FIRED'
export const EVENT_CHANGED = 'EVENT_CHANGED'
export const EVENT_ERROR = 'EVENT_ERROR'
export const LISTEN_FOR_EVENT = 'LISTEN_FOR_EVENT'
export const CONTRACT_INITIALIZING = 'CONTRACT_INITIALIZING'
export const CONTRACT_INITIALIZED = 'CONTRACT_INITIALIZED'
export const GOT_CONTRACT_VAR = 'GOT_CONTRACT_VAR'
export const DELETE_CONTRACT = 'DELETE_CONTRACT'
export const CONTRACT_SYNCING = 'CONTRACT_SYNCING'
export const CONTRACT_SYNCED = 'CONTRACT_SYNCED'
export const CONTRACT_SYNC_IND = 'CONTRACT_SYNC_IND'
export const ERROR_CONTRACT_VAR = 'ERROR_CONTRACT_VAR'
export const CALL_CONTRACT_FN = 'CALL_CONTRACT_FN'
export const SEND_CONTRACT_TX = 'SEND_CONTRACT_TX'
export const ADD_CONTRACT = 'ADD_CONTRACT'
export const ERROR_ADD_CONTRACT = 'ERROR_ADD_CONTRACT'
